module.exports = __webpack_public_path__ + "img/truck-ds.88818140.svg";